import type { ReactNode } from 'react';
import { Alert } from '@/design-system';
import { type AppRoute, mayOpen } from '@/app/routes';
import { useAuth } from '@/lib/auth/useAuth';

/**
 * A page opened by somebody it is not for — by a typed or shared address, since the
 * navigation never offers it — says so, rather than redirecting as if the address
 * were wrong.
 */
export function RequireAccess({ route, children }: { route: AppRoute; children: ReactNode }) {
  const { me } = useAuth();
  if (me && !mayOpen(route, me)) {
    return (
      <Alert tone="danger" title="Not permitted">
        {route.label} is for {route.access === 'reviewer' ? 'reviewers and administrators' : 'administrators'}. Ask
        an administrator if you need access.
      </Alert>
    );
  }
  return <>{children}</>;
}
